export default {
	'add-new-service': '',
	'the-service': '',
	services: '',
}